// extracted by mini-css-extract-plugin
export default {"textError":"styles_textError__USDK+","iconError":"styles_iconError__z-y8G"};